
  import HomeFotor from "@/components/home-fotor.vue"
  import HomeClipfly from "@/components/home-clipfly.vue"
  import HomeFotor2 from "@/components/home-fotor2.vue"
  import { isInClipFlyAppBrower } from "~/utils/common";

  export default {
    layout: "fotor-default",
    components: {
      HomeFotor,
      HomeClipfly,
      HomeFotor2,
    },
    data () {
      return {
        domain: null, // 默认 null，SSR 渲染时输出占位
      }
    },
    mounted () {
      const host = window.location.host
      if (host.includes('clipfly') || isInClipFlyAppBrower()) {
        this.domain = 'clipfly'
      } else if (host.includes('instaface')) {
        this.domain = 'instaface'
      } else {
        this.domain = 'fotor'
      }
    }
  }
